import {CrmContactList, ContactRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {CONTACT_TYPE} from "../labels";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

export const ContactListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<CrmContactList> = {
        title: "Contactos",
        onClick: "/app/admin/marketing/contact",
        headers: [
            {title: "Contacto"},
            {title: "Organización"},
            {title: "Cargo"},
            {title: "Email"},
            {title: "Teléfono"},
            {title: "Tipo"},
        ],
        decorator: (bean: CrmContactList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    <Stack direction="row" spacing={1.5} alignItems="center" sx={{minWidth: 0}}>
                        <PersonAvatar name={bean.surnamesAndName} size={30}/>
                        <Typography variant="body2" fontWeight={600} noWrap>{bean.surnamesAndName}</Typography>
                    </Stack>
                </TableCell>
                <TableCell>{bean.organization?.name ?? "-"}</TableCell>
                <TableCell>{bean.position ?? "-"}</TableCell>
                <TableCell>{bean.email ?? "-"}</TableCell>
                <TableCell>{bean.phone ?? "-"}</TableCell>
                <TableCell>{bean.type ? <SoftChip tone="neutral" label={CONTACT_TYPE[bean.type] ?? bean.type}/> : "—"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(ContactRestControllerApiFactory);
            return ctrl.pageContact(currentPage, size, undefined, undefined, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
